import { inject, Injectable } from '@angular/core';
import { AnalyticsService, trackTimedApiCall } from '../integrations/analytics';
import type {
  DiscountEstimateRequest,
  EstimateManagerRequest,
  EstimateManagerResponse,
} from '../models/estimates-orchestrator';
import { ShipmentFlowStateService } from '../services/shipment-flow-state.service';
import { AXIOS_INSTANCE } from './api-client.tokens';

@Injectable({ providedIn: 'root' })
export class EstimatesOrchestratorApiService {
  private readonly http = inject(AXIOS_INSTANCE);
  private readonly shipmentFlowState = inject(ShipmentFlowStateService);
  private readonly analytics = inject(AnalyticsService);

  /**
   * Requests priced delivery options from the Estimates Manager.
   * Sends the wizard flow id so every attestation JWT can be verified against the same session.
   */
  orchestrate(request: EstimateManagerRequest): Promise<EstimateManagerResponse> {
    const flowId = this.shipmentFlowState.ensureFlowId();

    return trackTimedApiCall(this.analytics, 'getServiceEstimates', () =>
      this.http
        .post<EstimateManagerResponse>('/estimates/estimate', request, {
          headers: { 'x-flow-id': flowId },
        })
        .then((response) => response.data),
    );
  }

  /**
   * Re-rates one attested Product × EDD selection using a coupon.
   * The prior JWT_est supplies trusted shipment and rate context without repeating orchestration.
   */
  discount(request: DiscountEstimateRequest): Promise<EstimateManagerResponse> {
    const flowId = this.shipmentFlowState.ensureFlowId();

    return this.http
      .post<EstimateManagerResponse>('/estimates/discount', request, {
        headers: { 'x-flow-id': flowId },
      })
      .then((response) => response.data);
  }
}
